import {
  diffSourcePlugin,
  headingsPlugin,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  quotePlugin,
  tablePlugin,
  thematicBreakPlugin,
  toolbarPlugin
} from '@mdxeditor/editor';
import type { Dayjs } from 'dayjs';
import { createElement } from 'react';

import { PRODUCTS } from '@/constants/products.constants';

import type { AttachmentFile } from '../Announcements.types';
import AnnouncementsTextEditorToolBar from './AnnouncementsTextEditorToolBar';

export enum AnnouncementDialogType {
  CREATE = 'Create',
  EDIT = 'Edit',
  VIEW = 'View'
}

export const CREATE_ANNOUNCEMENT_DIALOG_FORM_DEFAULT_VALUES = {
  title: '',
  body: '',
  id: '',
  org_list: '',
  attachments: [] as AttachmentFile[],
  send_email: true,
  scheduled_at: null as null | string | Dayjs,
  is_published: false,
  schedule: false
};

export const ORG_GROUP_OPTIONS = [
  {
    id: 100000,
    name: 'All Organizations',
    group: 'Select All',
    label: 'ALL',
    selected: false
  },
  {
    id: 200000,
    name: 'All EDR Clients',
    group: 'Service',
    label: PRODUCTS.EDR,
    selected: false
  },
  {
    id: 300000,
    name: 'All VMP Clients',
    group: 'Service',
    label: PRODUCTS.VMP,
    selected: false
  },
  {
    id: 400000,
    name: 'All Network Clients',
    group: 'Service',
    label: PRODUCTS.NET,
    selected: false
  },
  {
    id: 500000,
    name: 'All Log Clients',
    group: 'Service',
    label: PRODUCTS.LOG,
    selected: false
  }
];

export const SERVICE_GROUPS = [
  'All EDR Clients',
  'All VMP Clients',
  'All Network Clients',
  'All Log Clients'
];

export const ANNOUNCEMENT_MDX_EDITOR_CONFIG = [
  diffSourcePlugin(),
  headingsPlugin(),
  listsPlugin(),
  quotePlugin(),
  tablePlugin(),
  thematicBreakPlugin(),
  linkPlugin(),
  linkDialogPlugin(),
  toolbarPlugin({
    toolbarContents: () => createElement(AnnouncementsTextEditorToolBar)
  })
];
